import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { EditMasterPlanLocationRequest,  } from "../../domain";
import { MasterPlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class EditMasterPlanLocationUsecase implements UseCase<EditMasterPlanLocationRequest, boolean> {

    constructor(private readonly masterPlanRepository: MasterPlansRepository) {
  }

  execute(params: EditMasterPlanLocationRequest): Observable<boolean> {
    return this.masterPlanRepository.editMasterPlanLocation(params);
  }

}
